module.exports = __webpack_public_path__ + "img/1-cartoon-content.45002b99.jpg";